import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { products } from '../../../../../redux/products/action';
import { selectListItems } from '../../../../../redux/library/selector';
import * as R from 'ramda'
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import SocialProfilesComponent from '../components/social-profiles.component';
import { socialProfiles } from '../../../../../redux/social-profiles/action';
import { selectSocialProfilesQueryItems } from '../../../../../redux/social-profiles/selector';
import { selectTemplatesListItems } from '../../../../../redux/templates/selector';
import storePersist from '../../../../../redux/storePersist';
import { dbas } from '../../../../../redux/dbas/action';
import { orgRegistries } from '../../../../../redux/org-registries/action';
import { selectOrgRegistriesListItems } from '../../../../../redux/org-registries/selector';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../redux/account-types/action';
import { ListCriteria } from '../../../types/list-criteria';
import { selectProductsListItems } from '../../../../../redux/products/selector';

let currentChange: any = {}
const ManagementSocialProfile = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector((selectSocialProfilesQueryItems))
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductsListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const channelLists = useSelector(selectListItems)
  const templatesItems = useSelector(selectTemplatesListItems)
  const websitesItems = useSelector(selectWebsitesListItems)
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const orgRegistryItems = useSelector(selectOrgRegistriesListItems)
  const dbasItems = useSelector(selectDbasListItems)
  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedSocialProfiles, setSelectedSocialProfiles] = useState<any>({
    BodyContent: '',
    DesignFileurls: [],
    Attachmenturls: [],
    MappedEntities: []
  })
  const [selectedFunctions, setSelectedFunctions] = useState<any>([])
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [accountTypesList, setAccountTypesList] = useState<any>([]);
  const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
  const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
  const accountTypeItems = useSelector(selectAccountTypesListItems)
  const [accountsList, setAccountsList] = useState<any>([])
  const libraryData = useSelector(selectListItems)
  const TypeData = libraryData?.result?.Type

  const listAccountTypes = async () => {
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listDBAAccountTypes = async () => {
    // v6.1/organization/dbn/dba-type-dba-mappings
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listDBNBizAccountTypes = async () => {
    // v6.1/organization/dbn/biz-net-types
    await dispatch(accountTypes.resetAction({ actionType: 'list' }))
    await dispatch(accountTypes.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
      entity: 'accountTypes',
      jsonData: {}
    }))
  }

  const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
    await dispatch(accounts.resetAction({ actionType: 'list' }))
    await dispatch(accounts.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
      entity: 'accounts',
      jsonData: {
        "Filters": filterCriteria,
        "Searches": searchCriteria,
        "DateCriteria": dateCriteria,
      }
    }))
  }



  const fetchSocialProfileId = () => {
    dispatch(socialProfiles.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/social-profiles/query`,
      entity: 'socialProfiles', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(
    () => {
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
        }
      })).then(() => {
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          }
        }))
      }).then(() => {
        dispatch(categories.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
          entity: 'categories',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(dbas.list({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
          entity: 'dbas',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(orgRegistries.list({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/fetch`,
          entity: 'orgRegistries',
          jsonData: {
            "Context": {},
            "Records": [{ IsBothTenantANDDBNBased: true }],
            "Pagination": {

            }
          }
        }))
      }).then(() => {
        dispatch(products.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
          entity: 'products',
          jsonData: {
          }
        }))
      }).then(() => {
        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
          entity: 'accounts',
          jsonData: {
            Context: {},
            Records: [
              {
                IsProxyAccount: false
              }
            ],
            Pagination: {
            }

          }
        }))
      }).then(() => {
        dispatch(tenantFunctions.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
            Filters: [
              {
                FieldName: 'IsTemplateMappingEnabled',
                FieldText: 'TemplateMappingEnabled',
                FieldType: 'boolean',
                FilterOperatorId: 1,
                FieldValue: true
              }
            ]


          }
        }))
      })
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

        }
      }));
      if (parmas?.id > 0) {
        fetchSocialProfileId()
        setIsLoading(false)
      }
      else {
        const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
        setSelectedFunctions(localSelectedFunction)


        setIsLoading(false)
      }
    },
    []
  )

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }


  useEffect(
    () => {

      if (isQuery) {
        setSelectedSocialProfiles(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedFunctionArg: queryItems?.result?.items?.MappedEntities });
        setSelectedFunctions(localSelectedService)


      }
    },
    [isQuery]
  )


  const deleteSelectedFunctions = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      selectedFunctions?.splice(
        index,
        1
      )
    }
    handleClose()
  }
  const addNewRow = ({ selectedFunctionArg }: any) => {
    const localSelectedFunction = deepCopy(selectedFunctionArg)
    const newsFunctions = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,


    }
    if (localSelectedFunction.length === 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''
    ) {
      localSelectedFunction?.push(newsFunctions)
    }

    return localSelectedFunction
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSocialProfiles({ ...selectedSocialProfiles, [field]: event });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedFunctions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedFunctions(items);
  }


  useEffect(() => {
    setAssociatedAccountTypeId(selectedSocialProfiles?.OwnerTypeId);
    setOwnerLevelId(selectedSocialProfiles?.OwnerLevelId);
  }, [selectedSocialProfiles]);

  useEffect(() => {
    if (associatedAccountTypeId && accountTypesList) {
      const accountTypeName = accountTypesList?.find(
        (item: any) => item.Id === associatedAccountTypeId
      )?.Name;
      const accountTypeValue = TypeData.find(
        (type: any) => type.Text === accountTypeName
      )?.Text;
      if (accountTypeValue) {
        listAccountsByType({
          filterCriteria: [{
            "FieldName": "Type",
            "FilterOperatorId": 6,
            "FieldValue": accountTypeValue,
            "FieldType": "text"
          }]
        })
      }
    }
  }, [accountTypesList, associatedAccountTypeId]);




  useEffect(() => {
    switch (ownerLevelId) {
      case 10:
        listAccountTypes();
        break;
      case 11:
        listDBAAccountTypes();
        break;
      case 12:
        listDBNBizAccountTypes();
        break;
      default:
        dispatch(accountTypes.resetAction({ actionType: 'list' }))
        break;

    }
  }, [ownerLevelId]);

  useEffect(() => {
    switch (ownerLevelId) {
      case 10:
        setAccountTypesList(accountTypeItems?.result?.items);
        setAccountsList([]);
        break;
      case 11:
        setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
        setAccountsList([]);
        break;
      case 12:
        setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
        setAccountsList([]);
        break;
      default:
        setAccountTypesList([]);
        setAccountsList([]);
        break;

    }
  }, [accountTypeItems]);

  useEffect(() => {
    dispatch(accounts.resetAction({ actionType: 'list' }))
    setAccountsList([])
  }, []);

  useEffect(() => {
    setAccountsList(accountItems?.result?.items || [])
  }, [accountItems]);





  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedSocialProfiles.IsApproved = true;
    selectedFunctions.splice(
      selectedFunctions.length - 1,
      1
    );
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )

    selectedSocialProfiles.MappedEntities = selectedFunctions
    if (parmas?.id > 0) {
      await dispatch(socialProfiles.resetAction({ actionType: 'update' }))
      await dispatch(socialProfiles.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/social-profiles`,
        entity: 'socialProfiles',
        jsonData: {
          Records: [
            selectedSocialProfiles
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(socialProfiles.resetAction({ actionType: 'create' }))
      await dispatch(socialProfiles.create({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/social-profiles`,
        entity: 'socialProfiles', jsonData: {
          Records: [
            selectedSocialProfiles
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const setCombinationInfo = async () => {
    let localSelectedFunction = deepCopy(selectedFunctions)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'OwnerTypeIdDONE'
    setSelectedFunctions(localSelectedFunction)
  }

  useEffect(
    () => {
      if (currentChange.field === 'OwnerId') {
        setCombinationInfo()
      }
    },
    [selectedFunctions]
  )
  const back = () => {
    navigate('/management/cms/social-profiles')
  }

  useEffect(() => {

  }, [selectedSocialProfiles]
  )


  const formatWebpagesListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Id,
        WebpageName: `${product?.Name} : ${product?.AccountName}`,
      };
      return item
    });
  };
  return (
    <>

      {isLoading ? <PageLoader /> :
        <SocialProfilesComponent
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedSocialProfiles={selectedSocialProfiles}
          socialProfileType={librariesItems?.SocialProfileType}
          selectedFunctions={selectedFunctions}
          categories={categoriesLists?.result?.items}
          accounts={accountItems?.result?.items}
          channels={channelLists?.result?.items}
          organizationUnits={organizationUnitsLists?.result?.items}
          dbas={dbasItems?.result.items}
          orgRegistries={orgRegistryItems?.result.items}
          products={productsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          deleteSelectedFunctions={deleteSelectedFunctions}
          tenantFunction={tenantfunctionsLists?.result?.items}
          templates={templatesItems?.result?.items}
          id={parmas?.id}
          accountTypesListLoading={accountTypeItems?.isLoading}
          accountTypesList={accountTypesList}
          accountListLoading={accountItems?.isLoading}
          accountsList={accountsList}
          isLoading={isLoading}
          policyOwnerType={libraryData?.result?.PolicyOwnerType}
          onFormItemChange={handleFormMediaItemChange}
          mediaFiles={mediaFiles}
          websites={websitesItems?.result?.items}
          webpages={formatWebpagesListData(webPagesItems?.result?.items)}
          tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
            (func: any) =>
              (func.Entities || []).map((entity: any) => ({
                label: entity.EntityName,       // what to show in dropdown
                value: entity.Id,               // OwnerTypeId
                FunctionName: func.FunctionName, // used for conditional logic
              })))}

        />}
    </>
  )

}

export default ManagementSocialProfile;